const actions = {
  SET_STATE: 'moderation/SET_STATE',
  MODERATION_ACTIVITY_LIST: 'moderation/MODERATION_ACTIVITY_LIST',
  MODERATION_FLAGGED_MESSAGES_LIST: 'moderation/MODERATION_FLAGGED_MESSAGES_LIST',
  MODERATION_REVIEWED_MESSAGES_LIST: 'moderation/MODERATION_REVIEWED_MESSAGES_LIST',
  MODERATION_RULES_LIST: 'moderation/MODERATION_RULES_LIST',
  MODERATION_KEYWORDS_LIST: 'moderation/MODERATION_KEYWORDS_LIST',
  MODERATION_RULE_REVISIONS_LIST: 'moderation/MODERATION_RULE_REVISIONS_LIST',
  MODERATION_REVIEW_MESSAGE: 'moderation/MODERATION_REVIEW_MESSAGE',
  MODERATION_CONFIGURATION_LIST: 'moderation/MODERATION_CONFIGURATION_LIST',
  MODERATION_LIST_RULES: 'moderation/MODERATION_LIST_RULES',
  MODERATION_GET_RULE: 'moderation/MODERATION_GET_RULE',
  MODERATION_GET_RULE_AND_RULE_REVISIONS: 'moderation/MODERATION_GET_RULE_AND_RULE_REVISIONS',
  MODERATION_DELETE_RULE: 'moderation/MODERATION_DELETE_RULE',
  CHANGE_MODERATION_RULE_STATUS: 'moderation/CHANGE_MODERATION_RULE_STATUS',
  MODERATION_ADD_RULE: 'moderation/MODERATION_ADD_RULE',
  MODERATION_UPDATE_RULE: 'moderation/MODERATION_UPDATE_RULE',
  MODERATION_LIST_CONFIGURATION: 'moderation/MODERATION_LIST_CONFIGURATION',
  MODERATION_LIST_KEYWORDS: 'moderation/MODERATION_LIST_KEYWORDS',
  MODERATION_DELETE_KEYWORD: 'moderation/MODERATION_DELETE_KEYWORD',
  MODERATION_ADD_KEYWORD: 'moderation/MODERATION_ADD_KEYWORD',
  MODERATION_UPDATE_KEYWORD: 'moderation/MODERATION_UPDATE_KEYWORD',
  MODERATION_GET_KEYWORD: 'moderation/MODERATION_GET_KEYWORD',
  MODERATION_LIST_DROPPED_MESSAGES: 'moderation/MODERATION_LIST_DROPPED_MESSAGES',
  MODERATION_LIST_FLAGGED_MESSAGES: 'moderation/MODERATION_LIST_FLAGGED_MESSAGES',
  MODERATION_LIST_REVIEWED_MESSAGES: 'moderation/MODERATION_LIST_REVIEWED_MESSAGES',
  MODERATION_ACCEPT_FLAGGED_MESSAGE: 'moderation/MODERATION_ACCEPT_FLAGGED_MESSAGE',
  MODERATION_APPROVE_FLAGGED_MESSAGE: 'moderation/MODERATION_APPROVE_FLAGGED_MESSAGE',
  MODERATION_BLOCK_FLAGGED_MESSAGE: 'moderation/MODERATION_BLOCK_FLAGGED_MESSAGE',
  MODERATION_BAN_FLAGGED_MESSAGE_SENDER: 'moderation/MODERATION_BAN_FLAGGED_MESSAGE_SENDER',
  MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS: 'moderation/MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS',
  GET_FLAGGEDBY_USERS: 'moderation/GET_FLAGGEDBY_USERS',
  UPDATE_MODERATION_GLOBAL_SETTINGS: 'moderation/UPDATE_MODERATION_GLOBAL_SETTINGS',
  GET_MODERATION_GLOBAL_SETTINGS: 'moderation/GET_MODERATION_GLOBAL_SETTINGS',
  ADD_CUSTOM_CATEGORY: 'moderation/ADD_CUSTOM_CATEGORY',
  FETCH_CUSTOM_CATEGORIES: 'moderation/FETCH_CUSTOM_CATEGORIES',
  DELETE_CUSTOM_CATEGORY: 'moderation/DELETE_CUSTOM_CATEGORY',
  UPDATE_CUSTOM_CATEGORY: 'moderation/UPDATE_CUSTOM_CATEGORY',
}

export default actions
